import Head from 'next/head';
import { NextSeo } from 'next-seo';
import { Carrier } from '@/screens/Carrier';

export default function CarrierPage() {
  return (
    <>
      <Head>
        <meta
          name="keywords"
          content="Freight logistics, freight technology, carrier operations, load board, freight factoring, fuel card, trucker fuel card, freight tms, truck management software, truck management system, freight dispatch, freight dispatching software, ELD integrations, fleet management software, fleet management services, trucking back office services, truck tracking service, freight performance reporting, trucking drive safety, carrier setup, carrier website"
        />
      </Head>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG}
        noindex={process.env.NOINDEX_FLAG}
        title="Freight Trucking Services and Software | Loadsmart"
        description="Enhance your freight operations with Loadsmart. Access our truck management software, factoring, fuel cards, and book shipments with our logistic carrier services."
        canonical="https://loadsmart.com/carrier/"
        openGraph={{
          url: 'https://loadsmart.com/carrier/',
        }}
      />
      <Carrier />
    </>
  );
}
